import api from "../service/service";
import * as types from "../store/consultaSolicitacao.actionTypes";
import formActions from "@common/store/form/form.actions";
import { takeEvery, call, put } from "redux-saga/effects";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.DECA_CONSULTA_SOLICITACAO_GET, consultar);
}

function* consultar(action) {
  const { payload } = action;

  const response = yield call(api.getIdSolicitacao, payload);
  const id = response.data;

  if (!id) return _alert.warning("Solicitação não encontrada.");
  else yield put(formActions.redirect("deca.retificarsolicitacao", { id }));
}
